import { Game, eAtlas_0 } from "../../../Game";
import { TextureAtlasUtils } from "../../../Utils/TextuAtlasUtils";
import { HUD } from "./HUD";
import { ScaleManager } from "../../../Utils/ScaleManager";
import { TouchFx } from "./TouchFx";
import { TIMER } from "../../Gameplay";



export class Tutorial {
    private static readonly TOUCH_FX_X = 150;

    private static readonly TOUCH_FX_INTERVAL = 1200;

    private _layer: pc.Entity;
    private _overlay: pc.Entity;

    private _touchFx: TouchFx;
    private _touchFxSide: number;
    private _touchFxSwitchSideTime: number;

    get active(): boolean { return this._layer.enabled; }

    //-------------------------------------------------------------------------
    //-------------------------------------------------------------------------
    constructor() {
        let layer = this._layer = new pc.Entity("tutorial");

        layer.addComponent(pc.eCompomentType.element, {
            type: pc.ELEMENTTYPE_GROUP,
            anchor: [0.5, 0.5, 0.5, 0.5],
            pivot: [0.5, 0.5],
            width: 0,
            height: 0,
        });
        layer.enabled = false;
        HUD.instance.screen.addChild(layer);

        // Screen Overlay
        this._overlay = new pc.Entity();
        this._overlay.addComponent(pc.eCompomentType.element, {
            type: pc.ELEMENTTYPE_IMAGE,
            anchor: [0.5, 0.5, 0.5, 0.5],
            pivot: [0, 0],
            color: new pc.Color(0, 0, 0),
            opacity: 0.3,
        });
        layer.addChild(this._overlay);

        // Cara rozdelujici obrazovku
        let atlas = Game.getTextureAtlas(0);
        let line = new pc.Entity();

        line.addComponent(pc.eCompomentType.element, {
            type: pc.ELEMENTTYPE_IMAGE,
            texture: atlas.texture,
            rect: TextureAtlasUtils.getAtlasFrameRegion(atlas, eAtlas_0.tutLine),
            anchor: [0.5, 0.5, 0.5, 0.5],
            pivot: [0.5, 0.5],
            width: 4,
            height: 1120,
            opacity: 0.4
        });
        layer.addChild(line);

        // Touch efekt
        this._touchFx = new TouchFx(layer);

        // Leva ruka
        let lHand = new pc.Entity();
        lHand.addComponent(pc.eCompomentType.element, {
            type: pc.ELEMENTTYPE_IMAGE,
            texture: atlas.texture,
            rect: TextureAtlasUtils.getAtlasFrameRegion(atlas, eAtlas_0.tutHand),
            anchor: [0.5, 0.5, 0.5, 0.5],
            pivot: [0.5, 0.75],
            width: 134,
            height: 174,
        });
        layer.addChild(lHand);
        lHand.setLocalScale(-1, 1, 1);

        // Prava ruka
        let rHand = new pc.Entity();
        rHand.addComponent(pc.eCompomentType.element, {
            type: pc.ELEMENTTYPE_IMAGE,
            texture: atlas.texture,
            rect: TextureAtlasUtils.getAtlasFrameRegion(atlas, eAtlas_0.tutHand),
            anchor: [0.5, 0.5, 0.5, 0.5],
            pivot: [0.5, 0.75],
            width: 134,
            height: 174,
        });
        layer.addChild(rHand);

        if (Game.scale.maxWidth < Game.scale.maxHeight) {
            lHand.setLocalPosition(-170, -200, 0);
            rHand.setLocalPosition(170, -200, 0);
        }
        else {
            lHand.setLocalPosition(-170, -130, 0);
            rHand.setLocalPosition(170, -130, 0);
        }
    }

    //-------------------------------------------------------------------------
    //-------------------------------------------------------------------------
    show(): void {
        if (!this.active) {
            this._layer.enabled = true;
            this.showTouchFx(-1);

            this.updatOverlaySize();
            Game.app.on(ScaleManager.EVENT_RESIZE, this.updatOverlaySize, this);
        }
    }

    //-------------------------------------------------------------------------
    //-------------------------------------------------------------------------
    reset(): void {
        if (this.active) {
            this._layer.enabled = false;
            Game.app.off(ScaleManager.EVENT_RESIZE, this.updatOverlaySize, this);
        }
    }

    //-------------------------------------------------------------------------
    //-------------------------------------------------------------------------
    update(): void {
        if (TIMER.time >= this._touchFxSwitchSideTime)
            this.showTouchFx(this._touchFxSide * -1);

        this._touchFx.update();
    }

    //-------------------------------------------------------------------------
    //-------------------------------------------------------------------------
    private showTouchFx(side: number): void {
        this._touchFxSide = side;
        this._touchFx.show(Tutorial.TOUCH_FX_X * side, Game.scale.maxWidth < Game.scale.maxHeight ? -160 : -90);
        this._touchFxSwitchSideTime = TIMER.time + Tutorial.TOUCH_FX_INTERVAL;
    }

    //-------------------------------------------------------------------------
    //-------------------------------------------------------------------------
    private updatOverlaySize(): void {
        let w = Game.scale.width;
        let h = Game.scale.height;

        this._overlay.element.width = w;
        this._overlay.element.height = h;
        this._overlay.setLocalPosition(-w / 2, -h / 2, 0);
    }
}